export default function activitiesByItemId(activities) {
  let output = {}
  Object.values(activities).forEach(activity => {
    output[activity.itemId] = activity
  })
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/activitiesByItemId.js